import MicroModal from '../components/MicroModal';

export default function modalBox() {
	const settings = {
		openTrigger         : 'data-modal-trigger',
		closeTrigger        : 'data-modal-close',
		openClass           : 'is-open',
		disableScroll       : true,
		disableFocus        : true,
		awaitOpenAnimation  : true,
		awaitCloseAnimation : true,
		debugMode           : false,
	};
	
	return MicroModal.init(settings);
}
